import {
  AppBar,
  Box,
  Drawer,
  Hidden,
  IconButton,
  Toolbar,
  Typography,
} from '@material-ui/core';
import {
  ClearAll,
  Home as HomeIcon,
  AssignmentInd as CourseIcon,
  Build as SkillsIcon,
  School as EducationIcon,
  ContactMail as ContactIcon,
  Apps as PortfolioIcon, // <-- Add this import
} from '@material-ui/icons';
import React, { useCallback, useState } from 'react';
import { Link } from 'react-router-dom';

import { heroInfo } from '../../data/data';
import Footer from '../footer';
import SliderItems from '../slider-items';
import { useStyles } from './styles/navbar';

const Navbar = () => {
  const classes = useStyles();
  const [slider, setSlider] = useState(false);

  const toggleSlide = useCallback(() => {
    setSlider((prevState) => !prevState);
  }, []);

  return (
    <Box component="nav">
      <AppBar position="static" className={classes.appBar}>
        <Toolbar className={classes.toolbar}>
          {/* Mobile Menu Button */}
          <Hidden mdUp>
            <IconButton onClick={toggleSlide} aria-label="Menu">
              <ClearAll className={classes.clearAll} />
            </IconButton>
          </Hidden>

          {/* Logo */}
          <Typography variant="h5" className={classes.logo}>
            <Link to="/" className={classes.title}>
              {heroInfo.name}
            </Link>
          </Typography>

          {/* Desktop Menu Items */}
          <Hidden smDown>
            <Box className={classes.navLinks}>
              <Link to="/" className={classes.navLink}>
                <HomeIcon fontSize="small" className={classes.navIcon} />
                <Typography variant="body1" className={classes.linkText}>
                  Home
                </Typography>
              </Link> <Link to="/portfolio" className={classes.navLink}>
                <PortfolioIcon fontSize="small" className={classes.navIcon} />
                <Typography variant="body1" className={classes.linkText}>
                Project
                </Typography>
              </Link>
             
              <Link to="/resume" className={classes.navLink}>
                <CourseIcon fontSize="small" className={classes.navIcon} />
                <Typography variant="body1" className={classes.linkText}>
                  Course
                </Typography>
              </Link>
              <Link to="/skills" className={classes.navLink}>
                <SkillsIcon fontSize="small" className={classes.navIcon} />
                <Typography variant="body1" className={classes.linkText}>
                  Skills
                </Typography>
              </Link>
              <Link to="/education" className={classes.navLink}>
                <EducationIcon fontSize="small" className={classes.navIcon} />
                <Typography variant="body1" className={classes.linkText}>
                  Education
                </Typography>
              </Link>
              <Link to="/contacts" className={classes.navLink}>
                <ContactIcon fontSize="small" className={classes.navIcon} />
                <Typography variant="body1" className={classes.linkText}>
                  Contacts
                </Typography>
              </Link>
              {/* --------- New Portfolio Link --------- */}
             
              {/* --------------------------------------- */}
            </Box>
          </Hidden>

          {/* Drawer for Mobile */}
          <Drawer anchor="left" open={slider} onClose={toggleSlide}>
            <SliderItems toggleSlide={toggleSlide} />
            <Footer />
          </Drawer>
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default Navbar;
